import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../Shared/API/config';

export const billPaymentApi = createApi({
  reducerPath: 'billPaymentApi',
  baseQuery,
  tagTypes: ['Bills', 'Charges'],
  endpoints: builder => ({
    getBill: builder.query({
      query: () => `/billing/bills`,
      providesTags: ['Bills'],
    }),
    createBill: builder.mutation({
      query: newBills => ({
        url: '/billing/bills',
        method: 'POST',
        body: newBills,
      }),
      invalidatesTags: ['Bills'],
    }),
    duplicateBill: builder.mutation<any, { billId: string; sessionId: string }>(
      {
        query: ({ billId, sessionId }) => ({
          url: `/billing/bills/${billId}/copy/${sessionId}`,
          method: 'POST',
        }),
        invalidatesTags: ['Bills'],
      }
    ),
    updateBill: builder.mutation({
      query: ({ id, updates }) => ({
        url: `/billing/bills/${id}`,
        method: 'PATCH',
        body: updates,
      }),
      invalidatesTags: ['Bills'],
    }),
    deleteBills: builder.mutation<void, number>({
      query: id => ({
        url: `/enrollment/Billses/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Bills'],
    }),
    getStudentBills: builder.query<any, string>({
      query: studentId => `/billing/students/${studentId}/bills`,
      providesTags: ['Bills'],
    }),
    getStudentCurrentBills: builder.query<any, string>({
      query: studentId => `/billing/students/${studentId}/bills/current`,
      providesTags: ['Bills'],
    }),
    getStudentBillPreview: builder.query<any, string>({
      query: studentId => `/billing/students/${studentId}/bill-preview`,
      providesTags: ['Bills', 'Charges'],
    }),
    createStudentBill: builder.mutation<
      any,
      { studentId: string; newBill: any }
    >({
      query: ({ studentId, newBill }) => ({
        url: `/billing/students/${studentId}/bills`,
        method: 'POST',
        body: newBill,
      }),
      invalidatesTags: ['Bills'],
    }),
  }),
});

export const {
  useGetBillQuery,
  useCreateBillMutation,
  useDuplicateBillMutation,
  useUpdateBillMutation,
  useGetStudentBillsQuery,
  useGetStudentCurrentBillsQuery,
  useGetStudentBillPreviewQuery,
  useCreateStudentBillMutation,
} = billPaymentApi;
